import * as API from '@/api';

export const tag = {
  state: {
    tagList: [],
    tagResult: { artworks: [], temples: [], themes: [], albums: [] },
    tagPages: {
      lastPage: 1,
      currentPage: 1,
      perPage: 6,
    }
  },
  getters: {
    tagList(state) {
      return state.tagList;
    },
    tagResult(state) {
      return state.tagResult;
    },
    tagPages(state) {
      return state.tagPages;
    }
  },
  mutations: {
    setTagList(state, payload) {
      state.tagList = payload;
    },
    setTagResult(state, payload) {
      state.tagResult = payload;
    },
    setTagPages(state, payload) {
      state.tagPages = {...state.tagPages, ...payload}
    }
  },
  actions: {
    async getTagList({ commit }) {
      const tagList = await API.GET('/tagGroups');
      commit('setTagList', tagList.data.tagGroup);
    },
    async getTagResult({ commit }, {tagId, params}) {
      const { data: {tags = {}, name} } = await API.GET(`/tags/${tagId}`, params) || {};
      const categories = ['artworks', 'albums', 'temples', 'themes'];
      let newTagList = {
        name: name,
      };

      categories.map((category) => {
        return newTagList[category] = filterCategoryArticles(tags.data, category);
      });

      function filterCategoryArticles(allArticles, category) {
        return allArticles.filter((article) => {
          const isOnArticle = article.hasOwnProperty('title') === true; // 因為後端會回傳已下架文章
          const isCorrectTypeArticle = category === categories[article.type - 1];

          // article.id 在 router link 作為超連結 reference
          article.id = article.reference_id;

          return isOnArticle && isCorrectTypeArticle;
        });
      }

      commit('setTagResult', newTagList);
      commit('setTagPages', {
        total: tags.total,
        currentPage: tags.current_page,
        lastPage: tags.last_page
      })
    }
  },
}
